import React, { useState } from 'react';
import styled from 'styled-components';
import { Cards } from './Cards';



const Outerbox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 45px;
  padding: 0 100px;

  @media screen and (min-width: 1517px) {
    padding: 0px 180px;
    gap: 45px;

  }

  @media (min-width: 1524px) and (max-width: 1920px) {
    padding: 0px 290px;

  }

  @media screen and (max-width: 767px) {
    flex-flow: column;

  }
`;

export const ExploreResearchSolutions = (props) => {
  const [temporaryhideImage, setTemporaryhideImage] = useState(true)

  return (
    <Outerbox temporaryhideImage={temporaryhideImage}>
      <Cards Teams={props.Teams} title={props.title} />
    </Outerbox>
  );
};
